function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Events } from '../utils/events';

// Releasing a dragged item will cause a click event to be called on it.
// A drag operation should usually not be treated as a click, so we need to
// make sure to call preventDefault on the event. We can then check
// "defaultPrevented" in click listeners to see whether a given click should
// be handled normally.
// For example, we don't always want to close the copy action/edit action
// sidebar when performing a drag (usually it would be registered as an
// outside click, thus collapsing the sidebar).
// The events listeners use capturing (instead of bubbling) because they need
// to fire before any other - usually bubbled - event listeners have a chance
// to react.

export default class PreventClick {
  constructor(modifierInstance) {
    _defineProperty(this, "element", void 0);
    _defineProperty(this, "modifierInstance", void 0);
    this.element = modifierInstance.draggableElement;
    this.modifierInstance = modifierInstance;
    this.onDragEnd = this.onDragEnd.bind(this);
    this.bindPreventClick = this.bindPreventClick.bind(this);
    this.unbindPreventClick = this.unbindPreventClick.bind(this);
    this.preventClick = this.preventClick.bind(this);
  }
  attach() {
    this.element.addEventListener(Events.DragEnd, this.onDragEnd);
  }
  detach() {
    this.element.removeEventListener(Events.DragEnd, this.onDragEnd);
    this.unbindPreventClick();
  }
  bindPreventClick() {
    window.addEventListener('click', this.preventClick, true);
    window.addEventListener('mousedown', this.unbindPreventClick, true);
    window.addEventListener('touchstart', this.unbindPreventClick, true);
  }
  unbindPreventClick() {
    window.removeEventListener('click', this.preventClick, true);
    window.removeEventListener('mousedown', this.unbindPreventClick, true);
    window.removeEventListener('touchstart', this.unbindPreventClick, true);
  }
  preventClick(event) {
    event.preventDefault();
    this.unbindPreventClick();
  }
  onDragEnd(event) {
    if (event.target === this.element) {
      this.bindPreventClick();
    }
  }
}